/**
 * Smooth scroll to section with ID and offset
 */

class SmoothScroll {
    constructor() {
        this.offset = 200; // Offset w pikselach
        this.init();
    }

    /**
     * Smooth scroll to element
     * @param {HTMLElement} target - Element do którego scrollujemy
     */
    scrollToElement(target) {
        if (!target) return;

        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = targetPosition - this.offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    /**
     * Obsługa kliknięcia w link z hash
     * @param {Event} e - Event object
     */
    handleClick(e) {
        const link = e.currentTarget;
        const href = link.getAttribute('href');
        
        // Sprawdź czy link zawiera hash
        if (!href || !href.includes('#')) return;
        
        const hash = href.split('#')[1];
        if (!hash) return;
        
        const targetElement = document.getElementById(hash);
        
        if (targetElement) {
            e.preventDefault();
            this.scrollToElement(targetElement);
            
            // Aktualizuj URL bez scrollowania
            if (history.pushState) {
                history.pushState(null, null, '#' + hash);
            }
        }
    }

    /**
     * Inicjalizacja
     */
    init() {
        // Znajdź wszystkie linki z hash
        const links = document.querySelectorAll('a[href*="#"]');
        
        links.forEach(link => {
            link.addEventListener('click', this.handleClick.bind(this));
        });

        // Obsługa początkowego hash w URL
        if (window.location.hash) {
            setTimeout(() => {
                const targetElement = document.getElementById(window.location.hash.substring(1));
                if (targetElement) {
                    this.scrollToElement(targetElement);
                }
            }, 100);
        }
    }
}

// Eksport dla użycia w innych plikach
export default SmoothScroll;
